import {
  Component,
  Input,
  ElementRef,
  ViewChild,
  AfterViewChecked,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatMessage, TypingIndicatorEvent } from '../../models';
import { MessageBubbleComponent } from '../message-bubble/message-bubble';
import { TypingIndicatorComponent } from '../typing-indicator/typing-indicator';

@Component({
  selector: 'app-message-list',
  standalone: true,
  imports: [CommonModule, MessageBubbleComponent, TypingIndicatorComponent],
  templateUrl: './message-list.html',
  styleUrls: ['./message-list.scss'],
})
export class MessageListComponent implements AfterViewChecked, OnChanges {
  @Input() messages: ChatMessage[] = [];
  @Input() currentUserId = '';
  @Input() typingIndicators: TypingIndicatorEvent[] = [];

  @ViewChild('scrollContainer') private scrollContainer!: ElementRef<HTMLDivElement>;
  private shouldAutoScroll = true;
  private needsScroll = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['messages'] && this.shouldAutoScroll) {
      this.needsScroll = true;
    }
  }

  ngAfterViewChecked(): void {
    if (this.needsScroll) {
      this.needsScroll = false;
      this.scrollToBottom();
    }
  }

  onScroll(): void {
    const el = this.scrollContainer?.nativeElement;
    if (!el) return;
    const atBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 40;
    this.shouldAutoScroll = atBottom;
  }

  /** Show a date separator when the date changes between messages. */
  showDateSeparator(index: number): boolean {
    if (index === 0) return true;
    const prev = new Date(this.messages[index - 1].createdOn).toDateString();
    const curr = new Date(this.messages[index].createdOn).toDateString();
    return prev !== curr;
  }

  dateSeparatorLabel(msg: ChatMessage): string {
    const d = new Date(msg.createdOn);
    const today = new Date();
    if (d.toDateString() === today.toDateString()) return 'Today';
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    if (d.toDateString() === yesterday.toDateString()) return 'Yesterday';
    const day = d.getDate();
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${day} ${monthNames[d.getMonth()]} ${d.getFullYear()}`;
  }

  private scrollToBottom(): void {
    const el = this.scrollContainer?.nativeElement;
    if (el) el.scrollTop = el.scrollHeight;
  }
}
